import '../controllers';
import * as Turbo from '@hotwired/turbo';

Turbo.start();
